module Meevo.Plugins.RoyaltyExport {
    "use strict";

    export class MainSection extends Meevo.Components.CommonClasses.CommonSectionBase {
        private context: RoyaltyExportContext;
        public reportsList: any = [];
        public disableCrud: boolean = true;
        public appointmentBookSettings: Meevo.Model.AppointmentBookSettings;
        public meevoDate: Date;

        constructor(protected params: Meevo.Model.ISectionParamsExtendedCommonDataService) {
            super(params.sectionId,
                params.displayNameContentKey,
                params.template,
                params.isPrimarySection,
                params.handlesOwnCrud,
                params.baseEndpoint,
                params.sectionEndpoint,
                params.loggingService,
                params.dataService,
                params.noun,
                params.identityService,
                params.sectionSecurityKey)

            this.isLoaded = true;
            this.context = params['context'];

            this.appointmentBookSettings = this.params.appSettings.APP_BUSINFOSETTINGS.appointmentBookSettings;
            this.loadReportsList();
            this.getMeevoDate();
        }

        // Get reports list
        loadReportsList(): angular.IPromise<any> {
            let criteria = {
                criteria: {
                    includeActive: true,
                    includeInactive: false,
                    coSearchType: 0,
                    coSearchResultFilter: 0,
                    maintenanceMode: true,
                    reportId: 224, // 224 - Core Royalty Report ID
                },
                pageNumber: 0,
                itemsPerPage: 5000,
                sortDirection: 0
            }

            return this.dataService.customMethodData(`${this.params.appSettings.API_ROOT}/${this.params.appSettings.API_ENDPOINTS.reportScheduler}/List`, 'POST', criteria).then((res) => {
                this.reportsList = res.data;
            });
        }

        // Get Meevo date
        getMeevoDate(): angular.IPromise<any> {
            return this.params.dataService.customMethodData(`${this.params.appSettings.API_ROOT}/Tenant/TenantDistribution`, 'GET', null).then((res) => {
                this.meevoDate = res.data.dateCreated;
            });
        }

        runReportNow(report: any): void {
            let options: Meevo.Components.Modal.IModalOptions = {
                templateUrl: 'app/plugins/royaltyExport/runNow/runNow.template.html',
                controller: 'meevo.plugins.royaltyExport.ModalRunNowController',
                controllerAs: 'vm',
                escapeToClose: false,
                clickOutsideToClose: false,
                locals: {
                    startDayOfWeek: this.appointmentBookSettings.startAppointmentBookDayOn,
                    meevoDate: this.meevoDate
                }
            }

            this.params.modalService.showCustom(options).then((res: any) => {
                this.params.busyService.start();
                this.params.dataService.customMethodData(`${this.params.appSettings.API_ROOT}/${this.params.appSettings.API_ENDPOINTS.reportScheduler}/${report.id}/Run`, 'POST', res.criteria).then(() => {
                    this.loadReportsList();
                    this.params.busyService.stop();
                    
                    this.context.usageTrackingLog(Meevo.Model.NounEnum.RoyaltyExport, Meevo.Model.VerbEnum.Ran, `Ran Royalty Export (${report.displayName})`);
                }).catch(() => {
                    this.params.busyService.stop();
                });
            });
        }
    }
}